import {
  SET_USER,
  UPDATE_CUSTOMER,
  UPDATE_PROMOTION,
  UPDATE_USER,
} from "./actionTypes";
import instance from "./instance";
import axios from "axios";
import { saveSearch } from "./store";
import { isCheckoutV2Enabled } from "../../checkout-v2/domain/featureFlags";

export const createCustomerWithAddressAndPhone = (withoutAddress = false) => {
  return async (dispatch, getState) => {
    const user = getState().auth.user;
    if (!user) return;

    const customerInfo = getState().customers;
    if (!customerInfo?.customerContact) return;
    if (
      !withoutAddress &&
      ((getState().store.store.settings.is_branch_based_ordering &&
        !getState().branch.branch) ||
        !customerInfo?.address) &&
      !getState().store.store.settings.enable_dot
    )
      return;

    try {
      const res = await instance.post("/create_customer_from_user/", {
        customer: customerInfo,
        branch: getState().branch,
      });

      if (res.data.success) {
        dispatch({ type: UPDATE_USER, payload: res.data });
      }
    } catch (error) {
      console.error(error);
    }
  };
};

export const logout = () => {
  return async (dispatch, getState) => {
    // try {
    //   const res = await instance.post("/rest-auth/logout/");
    // } catch (err) {
    //   console.error(err);
    // }
    localStorage.removeItem("stoken");
    delete instance.defaults.headers.common.Authorization;
    delete axios.defaults.headers.common.Authorization;
    let pastOrders = getState().auth.user?.past_orders;
    if (pastOrders || pastOrders?.length > 0) {
      dispatch({
        type: "REMOVE_USER_PAST_ORDER",
        payload: pastOrders,
      });
    }
    dispatch({ type: SET_USER, payload: null });
    if (isCheckoutV2Enabled(getState().store?.store?.settings)) {
      const address = getState().customers?.address || {};
      dispatch({ type: "CLEAR_USER" });
      dispatch({ type: "RESET_CUSTOMERS_REDUCER" });
      dispatch({ type: "MODIFY_ADDRESS", payload: {
        selectedDeliveryType: address.selectedDeliveryType,
        country: address.country, area: address.area, pickupArea: address.pickupArea,
      } });
      dispatch({ type: "CHECKOUT_V2_RESET" });
    }

    const smart_promos = getState().store?.store?.smart_promos || [];
    const customer = getState().customers;
    const branchDetails = getState().branch;
    const storeCategories = getState().store?.store?.categories || [];
    const storeSettings = getState().store?.store?.settings || {};
    const deliveryTime = getState().deliveryTime;
    if (storeSettings.enable_aseer_time) {
      await dispatch({ type: "RESET_CUSTOMERS_REDUCER" });

      setTimeout(() => {
        window.location.reload();
      }, 100);
    }
    if (getState().store?.store) {
      dispatch({
        type: UPDATE_PROMOTION,
        smart_promos: smart_promos,
        customerAddress: customer?.address || {},
        customerBin: customer?.bin || {},
        branchDetails: branchDetails,
        updatePromotionQuantity: false,
        authUser: null,
        storeCategories: storeCategories,
        storeSettings,
        deliveryTime,
      });
    }
  };
};

export const setUser = (key, history = null) => {
  return async (dispatch, getState) => {
    if (!key) {
      dispatch(logout());
      return null;
    }
    localStorage.setItem("stoken", key);
    axios.defaults.headers.common.Authorization = `Token ${key}`;
    instance.defaults.headers.common.Authorization = `Token ${key}`;
    dispatch({ type: "PROFILE_LOADING" });
    const country_code = getState().currency.selected;
    try {
      const res = await instance.post("/get_user_info/", { country_code });

      if (res.data.success) {
        let authUser = getState().auth.user?.user_id;
        const settings = getState().store?.store?.settings || {};
        const v2 = isCheckoutV2Enabled(settings);
        const current = getState();
        const preserveFulfillmentContext = v2 && Boolean(
          current.customers?.address?.area || current.customers?.address?.pickupArea ||
          current.branch?.branch || current.cart?.cart?.length || current.cart?.promo_items?.length,
        );

        dispatch({ type: SET_USER, payload: res.data });
        if (res.data.user?.past_orders?.length > 0) {
          dispatch({
            type: "ADD_TO_PAST_ORDERS_FROM_PROFILE",
            payload: res.data.user?.past_orders,
          });
        }
        if (
          res.data.addresses?.length &&
          !preserveFulfillmentContext &&
          !getState().branch.branch &&
          res.data.has_delivery
        ) {
          // This is only effective if it's branch based and the data has an indication that the store is branch basd
          // At this point, the store is not loaded yet, so there's no way to know if it's branch based or not
          // hence letting the backend tell us
          dispatch({
            type: "SET_BRANCH_FROM_SAVED_ADDRESS",
            payload: res.data,
          });
        }
        const require_dine_in_contact_info =
          settings.enable_table_qr && settings.require_dine_in_contact_info;
        await dispatch({
          type: UPDATE_CUSTOMER,
          payload: {
            ...res.data,
            addresses: res.data.addresses || [],
            hydrateProfileContact: v2,
            preserveFulfillmentContext,
            preferProfileContact: v2 &&
              (!authUser || authUser !== res.data.user?.user_id),
            require_dine_in_contact_info: require_dine_in_contact_info,
          },
        });

        if (
          res.data.force_number &&
          res.data.user?.provider !== "phone" &&
          !res.data.user.phone
        ) {
          if (history) {
            history.replace("/profile");
            history.push("/checkout/details", { prevPath: "profile" });
          }
        }
        if (!authUser) {
          authUser = getState().auth.user;
          const smart_promos = getState().store?.store?.smart_promos || [];
          const customer = getState().customers;
          const branchDetails = getState().branch;
          const storeCategories = getState().store?.store?.categories || [];
          const storeSettings = getState().store?.store?.settings || {};
          const deliveryTime = getState().deliveryTime;
          if (getState().store?.store) {
            dispatch({
              type: UPDATE_PROMOTION,
              smart_promos: smart_promos,
              customerAddress: customer?.address || {},
              customerBin: customer?.bin || {},
              branchDetails: branchDetails || {},
              updatePromotionQuantity: false,
              authUser: authUser,
              storeCategories: storeCategories,
              storeSettings,
              deliveryTime,
            });
          }
        }
        return res.data.user || null;
      } else {
        dispatch(logout());
        return null;
      }
    } catch (error) {
      if (error.response) {
        if (error.response.status == 401) {
          localStorage.removeItem("stoken");
          delete instance.defaults.headers.common.Authorization;
          delete axios.defaults.headers.common.Authorization;
          let pastOrders = getState().auth.user?.past_orders;
          if (pastOrders || pastOrders?.length > 0) {
            dispatch({
              type: "REMOVE_USER_PAST_ORDER",
              payload: pastOrders,
            });
          }
          dispatch({ type: SET_USER, payload: null });
        } else dispatch(logout());
      }
      console.error(error);
      return null;
    }
  };
};

export const removeFavoriteProduct = (productId, handleOpen) => {
  return async (dispatch) => {
    try {
      const res = await instance.post("/remove_favorite_product/", {
        productId: productId,
      });
      if (res.data.success === true) {
        dispatch({
          type: "REMOVE_FAVORITE_PRODUCT",
          payload: {
            productId: productId,
          },
        });
        setTimeout(() => {
          // just to prevent spamming
          handleOpen();
        }, 1000);
      }
    } catch (err) {
      console.error(err);
    }
  };
};
export const addFavoriteProduct = (productId, userId, handleOpen) => {
  return async (dispatch) => {
    try {
      const res = await instance.post("/add_favorite_product/", {
        productId: productId,
        userId: userId,
      });
      if (res.data.success === true) {
        dispatch({
          type: "ADD_FAVORITE_PRODUCT",
          payload: {
            productId: productId,
            id: res.data.id,
          },
        });
        setTimeout(() => {
          // just to prevent spamming
          handleOpen();
        }, 1000);
      }
    } catch (err) {
      console.error(err);
    }
  };
};
export const fetchFavoriteProduct = (setLoading) => {
  return async (dispatch, getState) => {
    try {
      const settings = getState().store.store.settings;
      const branch = getState().branch;
      const channel = getState().promise?.src || "web";
      const checkIfBranchBased =
        settings.is_branch_based_ordering && (branch.branch || branch.bdc);

      setLoading(true);
      const res = await instance.post("/fetch_favorite_product/", {
        branch_id: checkIfBranchBased ? branch.branch : null,
        channel: channel,
      });
      dispatch({
        type: "FETCH_FAVORITE_PRODUCT",
        payload: {
          data: res.data.categories,
        },
      });
      let products = [];
      res.data.categories.forEach(
        (cat) => (products = products.concat(cat.products))
      );

      dispatch(saveSearch(products));
      setLoading(false);
    } catch (err) {
      setLoading(false);

      console.error(err);
    }
  };
};
